import { useState } from "react";
import { ContactProvider } from "@/context/ContactContext";
import { FeeBar } from "@/components/FeeBar";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { HowItWorks } from "@/components/HowItWorks";
import { Categories } from "@/components/Categories";
import { ProductStrip } from "@/components/ProductStrip";
import { Gallery } from "@/components/Gallery";
import { CustomPrints } from "@/components/CustomPrints";
import { ShippingMap } from "@/components/ShippingMap";
import { DownloadCTA } from "@/components/DownloadCTA";
import { Footer } from "@/components/Footer";

export default function Landing() {
  const [category, setCategory] = useState("All");

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const selectCategory = (c) => {
    setCategory(c);
    scrollTo("marketplace");
  };

  return (
    <ContactProvider>
      <div className="min-h-screen bg-background text-foreground">
        <FeeBar />
        <Nav />
        <main>
          <Hero onScrollTo={scrollTo} />
          <HowItWorks onScrollTo={scrollTo} />
          <Categories onSelect={selectCategory} />
          <Gallery category={category} onCategoryChange={setCategory} />
          <ProductStrip />
          <CustomPrints onScrollTo={scrollTo} />
          <ShippingMap />
          <DownloadCTA />
        </main>
        <Footer />
      </div>
    </ContactProvider>
  );
}
